import { QueryClient } from 'react-query'
import QueryKeys from './utils/constants/queryKeys'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

// High-traffic queries shared by many components (layout, dashboard, org/team
// selectors). A 60s staleTime lets staggered mounts share one cached result
// instead of each refiring the request. Kept per-key rather than global
// because much of the codebase populates state in onSuccess, which react-query
// v3 skips when a mount is served from fresh cache. Only add a key here after
// checking every call site derives from query data (not onSuccess) and that
// mutations invalidate it.
const SHARED_QUERY_STALE_TIME = 60 * 1000

;[
  QueryKeys.GET_ACCOUNT_ME,
  QueryKeys.GET_ORGS,
  QueryKeys.GET_SINGLE_ORG,
  QueryKeys.GET_TEAMS,
  QueryKeys.GET_ORG_SUB_STATUS,
  QueryKeys.GET_ORG_CLUBS,
  QueryKeys.GET_GENDER_SPEC,
  QueryKeys.GET_AGE_RESTRICTION,
  QueryKeys.GET_SUBSCRIPTION_DETAILS,
  QueryKeys.GET_COUNTRIES,
].forEach((key) => {
  queryClient.setQueryDefaults(key, { staleTime: SHARED_QUERY_STALE_TIME })
})

export default queryClient
